import React, { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Upload, message } from 'antd';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import loadingIcon from 'utils/icon/icon_spinner_black.svg';
import { handleMessage } from 'utils/helper/message';
import { AudioSquare } from 'iconsax-react';

export interface IProps {
  requiredSubtitle?: ReactNode;
  setSoundFile: React.Dispatch<any>;
}

const ReplaceSound: React.FC<IProps> = ({ requiredSubtitle, setSoundFile }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  const props = {
    name: 'file',
    action: '',
    showUploadList: false,
    beforeUpload: async (file) => {
      const isAuido =
        file.type === 'audio/mpeg' ||
        file.type === 'audio/wav' ||
        file.type === 'audio/ogg';

      if (!isAuido) {
        message.error(`${file.name} is not a auido file`);
      } else {
        if (file.size > 4000000) {
          message.error(`Upload failed. Max size for files is 4 MB.`);
        } else {
          try {
            setSoundFile(file);
          } catch (err) {
            setLoading(false);
            handleMessage(message, 'error', 'Upload failed');
          }
        }
      }
    },
  };

  return (
    <UploadWrapper>
      <div className='uploadTotalWrap'>
        <p>
          {t(
            'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.soundContent.editModal.soundFile',
          )}
        </p>
        <Upload {...props} maxCount={1}>
          <ListImageWrapper>
            {loading ? (
              <img
                src={loadingIcon}
                alt='loading'
                style={{
                  margin: 0,
                }}
              />
            ) : (
              <AudioSquare size='24' color={theme.colors.dark_200} />
            )}
            <p className='replace'>Replace</p>
          </ListImageWrapper>
        </Upload>
        {!requiredSubtitle ? (
          <p className='turText'>{t('updateStory.form.required')}</p>
        ) : (
          requiredSubtitle
        )}
      </div>
    </UploadWrapper>
  );
};

export default ReplaceSound;

const UploadWrapper = styled.div`
  display: flex;
  .ant-upload,
  .ant-upload-wrapper {
    width: 100%;
  }
  .emptyImage {
    height: 144px;
    border: 1px solid ${theme.colors.dark_100};
    border-radius: 4px;
    border-style: dotted;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 24px;
    & > * + * {
      margin-top: 10px;
      max-width: 145px;
      text-align: center;
    }
    cursor: pointer;
  }
  .turText {
    font-size: ${theme.fontSizes.sm};
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    margin-top: 8px;
  }
  .emptyImageText {
    color: ${theme.colors.dark_500};
    font-size: ${theme.fontSizes.normal};
    font-weight: ${theme.fontWeights.normal};
    line-height: 24px;
    letter-spacing: 0.2px;
  }
  .uploadTotalWrap {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  & > * + * {
    /* margin-left: 24px; */
    /* column-gap: 24px; */
  }
`;

const ListImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  margin-top: 8px;
  background-color: ${theme.colors.aliceBlue};
  border-radius: 4px;
  p {
    font-size: ${theme.fontSizes.small};
    font-weight: ${theme.fontWeights.medium};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_500};
  }
  p:nth-child(2n) {
    color: ${theme.colors.dark_300};
    padding-left: 8px;
  }
  img {
    margin-left: auto;
    cursor: pointer;
  }
  .replace {
    cursor: pointer;
    color: ${theme.colors.blue_500} !important;
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.medium};
    line-height: 20px; /* 166.667% */
    letter-spacing: 0.2px;
  }
`;
